/**
 * 생성기 자료의 클라이언트 검사·표시 — 붙이는 순간 형식·크기를 걸러 안내하고, 통과한 자료는
 * 곧바로 서버에 사전 등록한다(useAiGenerateDockPreregistration). 최종 판정은 서버 추출기가 한다.
 */
import {
  AiFileSizeLimitMb,
  ALLOWED_AI_FILE_EXTENSIONS,
} from '@/shared/features/ai-quiz-generation/consts/fileExtensions';

import { type AiGenerateDockLinkSourceType } from '../consts/aiGenerateDock.const';

const BYTES_PER_MB = 1024 * 1024;

export const YOUTUBE_HOSTS = ['youtube.com', 'youtu.be'];

export type AiGenerateDockFileCheck = 'ok' | 'too_large' | 'not_allowed';

export const checkAiGenerateDockFile = (file: {
  name: string;
  size: number;
}): AiGenerateDockFileCheck => {
  const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
  if (!(ALLOWED_AI_FILE_EXTENSIONS as readonly string[]).includes(extension)) {
    return 'not_allowed';
  }
  return file.size > AiFileSizeLimitMb * BYTES_PER_MB ? 'too_large' : 'ok';
};

/** http(s) 주소인지, 유튜브 탭이면 유튜브 주소인지만 본다. */
export const isAiGenerateDockLinkValid = (
  sourceType: AiGenerateDockLinkSourceType,
  url: string,
): boolean => {
  let parsed: URL;
  try {
    parsed = new URL(url.trim());
  } catch {
    return false;
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return false;
  if (sourceType === 'website') return true;

  const host = parsed.hostname.toLowerCase();
  return YOUTUBE_HOSTS.some(
    youtubeHost => host === youtubeHost || host.endsWith(`.${youtubeHost}`),
  );
};

export const formatAiGenerateDockFileSize = (bytes: number): string =>
  bytes >= BYTES_PER_MB
    ? `${(bytes / BYTES_PER_MB).toFixed(1)}MB`
    : `${Math.max(1, Math.round(bytes / 1024))}KB`;
